module.exports = "./img/fc20d59e8527b1cb28dec799f1d73db2.jpg";